module.exports = __webpack_public_path__ + "static/assets/ad2b43907e8d2dd5826daec7af02719f.svg";